import i18nIsoCountries from 'i18n-iso-countries';
import store from 'store/store';
import customEnCountries from 'constants/locales/en/countries.en.json';

export const getCountriesNamesBasedOnLanguage = (language) => {
  // i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/en.json'));
  i18nIsoCountries.registerLocale(require('i18n-iso-countries/langs/sv.json'));

  if (language === 'en') return customEnCountries;

  return i18nIsoCountries.getNames(language);
};

// const compare = (a, b) => {
//   if (a.label < b.label) return -1;
//   if (a.label > b.label) return 1;
//   return 0;
// };

export const countriesMapper = (countriesList) => {
  const countriesArray = Object.keys(countriesList).map((key) => ({
    value: key,
    label: countriesList[key],
  }));

  // return countriesArray.sort(compare); // for english has same results without sorting
  return countriesArray;
};

export const setCountriesRedux = (language) => {
  const countriesList = getCountriesNamesBasedOnLanguage(language);
  const countriesMappedList = countriesMapper(countriesList);

  return {
    countriesList,
    countriesMappedList,
  };
};

export const getMatchingCountryValue = (code) =>
  store.getState().countries.countriesMappedList.find((country) => country.value === code);

export const setDefalutMultiSelectValue = (countriesNamesArray) => {
  return countriesNamesArray
    ? countriesNamesArray.map((countryName) =>
        store.getState().countries.countriesMappedList.find((country) => country.label === countryName)
      )
    : [];
};

export const getCountriesList = () => store.getState().countries.countriesList;
